import { AssetGenerator } from './AssetGenerator';
export class FontAssetGenerator extends AssetGenerator {
    getParentFoldersPath() {
        return 'fonts/';
    }
}
